export const SESSION_DURATION_MS = 60 * 60 * 1000;

const getRequestDurationMs = (access) => {
  const minutes = Number(access?.requestedDurationMinutes);
  if (Number.isFinite(minutes) && minutes > 0) return minutes * 60 * 1000;
  return SESSION_DURATION_MS;
};

export const getSessionExpiresAt = (access) => {
  if (!access) return null;
  if (access.sessionExpiresAt) return new Date(access.sessionExpiresAt);
  if (access.status === 'approved' && access.respondedAt) {
    return new Date(new Date(access.respondedAt).getTime() + getRequestDurationMs(access));
  }
  return null;
};

export const isSessionActive = (access, now = Date.now()) => {
  if (!access || access.status !== 'approved') return false;
  if (access.sessionActive === false) return false;
  const expiresAt = getSessionExpiresAt(access);
  if (!expiresAt) return false;
  return expiresAt.getTime() > now;
};

export const isSessionExpired = (access, now = Date.now()) => {
  if (!access || access.status !== 'approved') return false;
  const expiresAt = getSessionExpiresAt(access);
  if (!expiresAt) return false;
  return expiresAt.getTime() <= now;
};

export const formatSessionRemaining = (access, now = Date.now()) => {
  const expiresAt = getSessionExpiresAt(access);
  if (!expiresAt) return '';
  const ms = Math.max(0, expiresAt.getTime() - now);
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')} remaining`;
  }
  return `${m}:${String(s).padStart(2, '0')} remaining`;
};
